module.exports = __webpack_public_path__ + "school/img/traditoinBg.0ec475d0.jpg";